export const likertTestErrorSelector = state => state.likertTest.error;
export const likertTestDataSelector = state => state.likertTest.likertTestData;
export const likertTestResultSelector = state => state.likertTest.likertTestResult;
export const isLikertFetchingSelector = state => state.likertTest.isFetching;
export const isPostingLikertResponsesSelector = state => state.likertTest.isPostingResponses;
